import { render, staticRenderFns } from "./safetyGearGiveInfo.vue?vue&type=template&id=f2796b6e"
import script from "./safetyGearGiveInfo.vue?vue&type=script&lang=js"
export * from "./safetyGearGiveInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2796b6e')) {
      api.createRecord('f2796b6e', component.options)
    } else {
      api.reload('f2796b6e', component.options)
    }
    module.hot.accept("./safetyGearGiveInfo.vue?vue&type=template&id=f2796b6e", function () {
      api.rerender('f2796b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearGiveInfo.vue"
export default component.exports